import { render } from "./AffiliateDataShow.vue?vue&type=template&id=662b8606"
import script from "./AffiliateDataShow.vue?vue&type=script&lang=js"
export * from "./AffiliateDataShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__